import * as React from 'react';
import { Modal, Input, Row, Col, Checkbox } from 'antd';
import Form, { FormItem } from '../../../../../components/Form';

interface ICustomerSettingsModalProps {
  order: GQL.IOrder;
  onSubmit: (data: any) => void;
  onClose: () => void;
}

interface ICustomerSettingsModalState {
  data: {
    email: string;
    phone: string;
    companyName: string | null;
    companyRegistrationNumber: string | null;
    companyVatNumber: string | null;
    companyVatNumberValid: boolean | null;
    invoiceFirstName: string | null;
    invoiceLastName: string | null;
  };
}

class CustomerSettingsModal extends React.Component<ICustomerSettingsModalProps, ICustomerSettingsModalState> {

  private form;

  constructor(props: ICustomerSettingsModalProps) {
    super(props);

    this.state = {
      data: {
        email: props.order.email,
        phone: props.order.phone,
        companyName: props.order.companyName,
        companyRegistrationNumber: props.order.companyRegistrationNumber,
        companyVatNumber: props.order.companyVatNumber,
        companyVatNumberValid: props.order.companyVatNumberValid,
        invoiceFirstName: props.order.invoiceFirstName,
        invoiceLastName: props.order.invoiceLastName,
      },
    };

    this.form = React.createRef;

    this.onSubmit = this.onSubmit.bind(this);
    this.onChange = this.onChange.bind(this);
  }

  public render() {
    return (
      <div>
        <Modal
          title="Customer settings"
          visible={true}
          width={'70%'}
          okText={'Save changes'}
          onOk={this.onSubmit}
          onCancel={this.props.onClose}
          destroyOnClose={true}
          maskClosable={false}
        >
          <Form
            ref={f => this.form = f}
            displayFooter={false}
            onSubmit={this.onSubmit}
            onCancel={this.props.onClose}
          >
            <Row gutter={15}>
              <Col span={12}>
                <FormItem label={'First name'} required={true}>
                  <Input
                    name={'invoiceFirstName'}
                    placeholder="Enter customer first name"
                    value={this.state.data.invoiceFirstName || ''}
                    required={true}
                    autoFocus={true}
                    onChange={this.onChange}
                  />
                </FormItem>
                <FormItem label={'Last name'} required={true}>
                  <Input
                    name={'invoiceLastName'}
                    placeholder="Enter customer last name"
                    value={this.state.data.invoiceLastName || ''}
                    required={true}
                    onChange={this.onChange}
                  />
                </FormItem>
                <FormItem label={'E-mail'} required={true}>
                  <Input
                    name={'email'}
                    placeholder="Enter e-mail"
                    value={this.state.data.email}
                    required={true}
                    onChange={this.onChange}
                  />
                </FormItem>
                <FormItem label={'Phone'} required={true}>
                  <Input
                    name={'phone'}
                    placeholder="Enter customer phone"
                    value={this.state.data.phone || ''}
                    required={true}
                    onChange={this.onChange}
                  />
                </FormItem>
              </Col>
              <Col span={12}>
                <FormItem label={'Company name'}>
                  <Input
                    name={'companyName'}
                    placeholder="Enter company name"
                    value={this.state.data.companyName || ''}
                    onChange={this.onChange}
                  />
                </FormItem>
                <FormItem label={'Company registration number'}>
                  <Input
                    name={'companyRegistrationNumber'}
                    placeholder="Enter company registration number"
                    value={this.state.data.companyRegistrationNumber || ''}
                    onChange={this.onChange}
                  />
                </FormItem>
                <FormItem label={'Company VAT number'}>
                  <Input
                    name={'companyVatNumber'}
                    placeholder="Enter company VAT number"
                    value={this.state.data.companyVatNumber || ''}
                    onChange={this.onChange}
                  />
                </FormItem>
                <FormItem>
                  <Checkbox
                    name={'companyVatNumberValid'}
                    checked={this.state.data.companyVatNumberValid || false}
                    onChange={this.onChange}
                  >
                    Vat number valid
                  </Checkbox>
                </FormItem>
              </Col>
            </Row>
          </Form>
        </Modal>
      </div>
    );
  }

  private onChange(e: any) {
    const { name, value, checked } = e.target;

    const inputValue = value !== null && value !== undefined ? value : checked;

    this.setState({
      data: { ...this.state.data, [name]: inputValue }
    });
  }

  private onSubmit() {
    if (this.form) {
      if (this.form.validate()) {
        this.props.onSubmit(this.state.data);
      }
    }
  }
}

export default CustomerSettingsModal;


// WEBPACK FOOTER //
// ./src/scenes/OrderView/OrderView/CustomerSettings/components/Modal.tsx